// extracted by mini-css-extract-plugin
export var aircallIframe = "_go-3";
export var fabContainer = "_go-5";
export var fabRinging = "_go-6";
export var loadingOverlay = "_go-4";
export var pulse = "_go-7";
export var widgetContent = "_go-2";
export var widgetPanel = "_go-0";
export var widgetPanelExpanded = "_go-1";